(() => {
 const setup=()=>{
  const root=document.querySelector('[data-footer-motion]');
  if(!root||root.dataset.footerReady||!window.gsap)return;
  root.dataset.footerReady='true';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),gsap=window.gsap;
  if(reduced.matches)return;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   gsap.fromTo([...entry.target.children],{y:18,opacity:0,clipPath:'inset(100% 0 0 0)'},{y:0,opacity:1,clipPath:'inset(0% 0 0 0)',duration:.85,stagger:.07,ease:'power4.out',clearProps:'transform,opacity,clipPath'});
   observer.unobserve(entry.target);
  }),{threshold:.1});
  root.querySelectorAll('.mh-pro-help,.mh-pro-directory,.mh-pro-contactbar').forEach(el=>observer.observe(el));
  root.querySelectorAll('.mh-pro-directory nav a,.mh-footer-action a').forEach(el=>{
   el.addEventListener('pointerenter',e=>{if(reduced.matches||e.pointerType==='touch')return;gsap.to(el,{x:3,duration:.3,ease:'power3.out',overwrite:true});});
   el.addEventListener('pointerleave',()=>gsap.to(el,{x:0,duration:.4,ease:'power4.out',overwrite:true,clearProps:'transform'}));
  });
  reduced.addEventListener('change',()=>{if(reduced.matches){observer.disconnect();gsap.killTweensOf(root.querySelectorAll('*'));gsap.set(root.querySelectorAll('*'),{clearProps:'transform,opacity,clipPath'});}});
 };
 setup();window.addEventListener('load',setup,{once:true});document.addEventListener('shopify:section:load',setup);
})();
